module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('demo', {
    staticClass: "radio-demo",
    attrs: {
      "title": "Radio"
    }
  }, [_c('demo-item', {
    attrs: {
      "name": "size",
      "description": "大小",
      "code": _vm.code
    },
    slot: "left"
  }, [_c('Radio', {
    attrs: {
      "size": 'sm'
    },
    model: {
      value: (_vm.test),
      callback: function($$v) {
        _vm.test = $$v
      },
      expression: "test"
    }
  }, [_vm._v("单选按钮")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "size": 'md'
    },
    model: {
      value: (_vm.test),
      callback: function($$v) {
        _vm.test = $$v
      },
      expression: "test"
    }
  }, [_vm._v("单选按钮2")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "size": 'lg'
    },
    model: {
      value: (_vm.test),
      callback: function($$v) {
        _vm.test = $$v
      },
      expression: "test"
    }
  }, [_vm._v("单选按钮3")]), _vm._v(" "), _c('p', {
    staticClass: "radio-result"
  }, [_vm._v("已选中：" + _vm._s(_vm.test))])], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "value",
      "description": "指定值",
      "code": _vm.value_code
    },
    slot: "right"
  }, [_c('Radio', {
    attrs: {
      "value": 0
    },
    model: {
      value: (_vm.value_test),
      callback: function($$v) {
        _vm.value_test = $$v
      },
      expression: "value_test"
    }
  }, [_vm._v("单选按钮")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "value": 1
    },
    model: {
      value: (_vm.value_test),
      callback: function($$v) {
        _vm.value_test = $$v
      },
      expression: "value_test"
    }
  }, [_vm._v("单选按钮2")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "value": 2
    },
    model: {
      value: (_vm.value_test),
      callback: function($$v) {
        _vm.value_test = $$v
      },
      expression: "value_test"
    }
  }, [_vm._v("单选按钮3")]), _vm._v(" "), _c('p', {
    staticClass: "radio-result"
  }, [_vm._v("已选中：" + _vm._s(_vm.value_test))])], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "status",
      "description": "状态",
      "code": _vm.status_code
    },
    slot: "left"
  }, [_c('Radio', {
    model: {
      value: (_vm.status_test),
      callback: function($$v) {
        _vm.status_test = $$v
      },
      expression: "status_test"
    }
  }, [_vm._v("单选按钮")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.status_test),
      callback: function($$v) {
        _vm.status_test = $$v
      },
      expression: "status_test"
    }
  }, [_vm._v("已禁用")]), _vm._v(" "), _c('p', {
    staticClass: "radio-result"
  }, [_vm._v("已选中：" + _vm._s(_vm.status_test))])], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "color",
      "description": "颜色",
      "code": _vm.color_code
    },
    slot: "right"
  }, [_c('Radio', {
    model: {
      value: (_vm.color_test),
      callback: function($$v) {
        _vm.color_test = $$v
      },
      expression: "color_test"
    }
  }, [_vm._v("单选按钮")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "color": 'rgb(0, 160, 233)'
    },
    model: {
      value: (_vm.color_test),
      callback: function($$v) {
        _vm.color_test = $$v
      },
      expression: "color_test"
    }
  }, [_vm._v("单选按钮2(蓝色)")]), _vm._v(" "), _c('p', {
    staticClass: "radio-result"
  }, [_vm._v("已选中：" + _vm._s(_vm.color_test))])], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "reselect",
      "description": "重选(选中状态再次点击则取消)",
      "code": _vm.reselect_code
    },
    slot: "left"
  }, [_c('Radio', {
    attrs: {
      "reselect": true
    },
    model: {
      value: (_vm.reselect_test),
      callback: function($$v) {
        _vm.reselect_test = $$v
      },
      expression: "reselect_test"
    }
  }, [_vm._v("单选按钮")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "reselect": true
    },
    model: {
      value: (_vm.reselect_test),
      callback: function($$v) {
        _vm.reselect_test = $$v
      },
      expression: "reselect_test"
    }
  }, [_vm._v("单选按钮2")]), _vm._v(" "), _c('p', {
    staticClass: "radio-result"
  }, [_vm._v("已选中：" + _vm._s(_vm.reselect_test))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-178d0ad7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/demo/Radio.vue
// module id = 621
// module chunks = 0